/**
 * TCS Report — focused view of the TCS column from the tax engine.
 * Routed at `/reports/tcs`. See TaxReportPage for the shared renderer.
 */
import React from 'react';
import TaxReportPage from './TaxReportPage';

const TCSReport = () => (
  <TaxReportPage
    taxKey="tcs"
    title="TCS Report"
    subtitle="Quarterly TCS collected vs deposited to govt (Form 27EQ) — track deposits, challans & return filing."
  />
);

export default TCSReport;
